import { render, staticRenderFns } from "./WardGroupQueue.vue?vue&type=template&id=2b5b40c3&scoped=true"
import script from "./WardGroupQueue.vue?vue&type=script&lang=js"
export * from "./WardGroupQueue.vue?vue&type=script&lang=js"
import style0 from "./WardGroupQueue.vue?vue&type=style&index=0&id=2b5b40c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b40c3",
  null
  
)

export default component.exports